import { Component, OnInit } from '@angular/core';
import { InstitucionalService, InstitucionalItem } from './institucional.service';
import { NotificationService } from '../../core/notification.service';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-institucional-list',
  templateUrl: './institucional-list.component.html',
  styleUrls: ['./institucional-list.component.css']
})
export class InstitucionalListComponent implements OnInit {
  loading = false;
  items: InstitucionalItem[] = [];

  constructor(private svc: InstitucionalService, private notify: NotificationService, private router: Router) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.svc.list().subscribe({
      next: (res: any) => {
        this.items = res?.data ?? (Array.isArray(res) ? res : []);
        this.loading = false;
      },
      error: (err) => {
        console.error('[Institucional] erro ao listar', err);
        this.notify.showError('Erro ao carregar institucional');
        this.loading = false;
      }
    });
  }

  edit(item: InstitucionalItem) {
    this.router.navigate(['/admin/institucional', item.key, 'edit']);
  }
}
